import { render } from "./oneCom.vue?vue&type=template&id=611f8072&scoped=true"
import script from "./oneCom.vue?vue&type=script&lang=js"
export * from "./oneCom.vue?vue&type=script&lang=js"

import "./oneCom.vue?vue&type=style&index=0&id=611f8072&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611f8072"]])

export default __exports__